module.exports = __webpack_public_path__ + "img/exclamation-triangle-fill.5d0dae8f.svg";